<template>
    <div class="md-form">
        <div class="input-group">
            <div class="prepend-container" v-if="prepend">
                <slot name="prepend-body"></slot>
            </div>
            <input v-if="date" ref="date" v-on:blur="flatpickrInstance.setDate(inputData, true)" :name="name" v-bind:disabled="disabled" v-model="inputData" :placeholder="placeholder" v-bind:id="'flatpickr_'+this._uid" :class="['form-control',validClass]" type="text" :pattern="selected_regex" :required="required">
            <template v-else>
                <input v-if="!autocomplete" ref="non-date" v-on:keydown.enter="enterPressed" v-on:blur="$emit('focusoff',name)" :name="name" v-bind:disabled="disabled" v-on:input="inputChange($event)" v-model="inputData" :placeholder="placeholder" v-bind:id="'id_cleave'+this._uid" :class="['form-control class_cleave'+this._uid,validClass]" :type="type" :pattern="selected_regex" :required="required" :maxlength="binding_max_length" v-mask="decimal_places_mask"/>
                <template v-else>
                    <input ref="non-date" v-on:keydown.enter="enterPressed" v-on:keydown.down="autocompleteDown" v-on:keydown.up="autocompleteUp" v-on:blur="()=>{$emit('focusoff',name); showAutocomplete = false;}" :name="name" v-bind:disabled="disabled" v-on:input="inputChange($event)" v-model="inputData" :placeholder="placeholder" v-bind:id="'id_cleave'+this._uid" :class="['form-control class_cleave'+this._uid,validClass]" :type="type" :pattern="selected_regex" :required="required" :maxlength="binding_max_length" v-mask="decimal_places_mask"/>
                    <ul v-if="showAutocompleteParsed" class="autocomplete-list">
                        <li v-for="(data,idx) in autocompleteResults" :key="idx" :class="{'active': idx == autocompleteIndex}" @mousedown.prevent="selectAutocomplete(data)">
                            {{ autocompleteBuildTextField(data) }}
                        </li>
                    </ul>
                </template>
            </template>
        </div>
        <label v-if="label!=''" :for="'id_cleave'+this._uid">{{ label }}</label>
        <div v-if="valid_text != ''" class="valid-feedback">
            {{ valid_text }}
        </div>
        <div v-if="invalid_text != '' && validClass == 'invalid'" class="invalid-feedback">
            {{ invalid_text }}
        </div>
        <div v-if="warning_text != '' && validClass == 'warning'" class="warning-feedback">
            {{ warning_text }}
        </div>
    </div>
</template>
<script>
module.exports = {
    name:'customInputField',
    props:{
        options:{
            type:Object,
            default:()=>{}
        },
        name:{
            type:String,
            default:''
        },
        label:{
            type:String,
            default:''
        },
        placeholder:{
            type:String,
            default:''
        },
        type:{
            type:String,
            default:'text'
        },
        disabled:{
            type:Boolean,
            default:false
        },
        valid_text:{
            type:String,
            default:''
        },
        invalid_text:{
            type:String,
            default:''
        },
        warning_text:{
            type:String,
            default:''
        },
        value:{
            type:String,
            default:''
        },
        regex:{
            type:[String,RegExp],
            default:''
        },
        control_digit:{
            type:Boolean,
            default:false
        },
        required:{
            type:Boolean,
            default:false
        },
        date:{
            type:Boolean,
            default:false
        },
        date_locale:{
            type:String,
            default:''
        },
        date_format:{
            type:String,
            default:'ymd'
        },
        max_date:{
            type:String,
            default: null
        },
        prepend:{
            type:Boolean,
            default:false
        },
        max_length:{
            type:Number,
            default:undefined
        },
        decimal_places:{
            type:Number,
            default:null
        },
        autocomplete:{
            type:Boolean,
            default:false
        },
        autocomplete_select_field:{
            type:String,
            default:'numericcode'
        },
        url:{
            type:String,
            default:'/accounts/utils/countries?q='
        },
        autocompleteTextField:{
            type:String,
            default:'{numericcode} {name} (alpha2code)'
        },
        validateFuncActive:{
            type:Boolean,
            default:false
        },
        validateFunc:{
            default:null
        }
    },
    mounted() {
        if(this.date){
            this.flatpickrInstance = flatpickr("#flatpickr_"+this._uid,{
                allowInput: true,
                dateFormat: this.date_format,
                locale: this.date_locale.split('-')[0],
                maxDate: this.max_date,
                onChange: async (e,selected,i)=>{
                        this.inputData = selected;
                        // validate() is async (may call server-side validation). Await result
                        this.validStatus = await this.validate();
                        this.$emit('input', this.inputData);
                        this.$refs['date'].blur();
                    }
            });
        }
    },
    computed:{
        decimal_places_mask(){
            const max_length = parseInt(this.max_length)
            const decimal_places = parseInt(this.decimal_places)
            if(!isNaN(max_length) && !isNaN(decimal_places) && decimal_places > 0 && max_length > decimal_places){
                return `9{${max_length-decimal_places}}.9{${decimal_places}}`
            }
            return undefined
        },

        binding_max_length(){
            if(typeof this.decimal_places_mask !== 'undefined'){
                return this.max_length+1
            }
            if(this.autocomplete){
                if(/^\d+$/.test(this.inputData)){
                    return this.max_length
                }
                return undefined
            }
            return this.max_length
        },

        selected_regex:function(){
            if(this.regex!=""){
                if(typeof this.decimal_places_mask !== 'undefined'){
                    return `${this.regex}|^(${this.decimal_places_mask.replace(/9/g,'\\d')})$`;
                }
                return this.regex;
            }
            else if(typeof this.validationRegex[this.type] != "undefined"){
                return this.validationRegex[this.type];
            }
            else{
                return undefined;
            }
        },
        showAutocompleteParsed(){
            if(this.autocompleteResults.length > 0){
                return this.showAutocomplete && !(this.autocompleteResults.length === 1 && this.inputData === this.autocompleteResults[0][this.autocomplete_select_field])
            }
            return false
        }
    },
    methods:{
        getCookie(name) {
                var cookieValue = null;
                if (document.cookie && document.cookie !== '') {
                    var cookies = document.cookie.split(';');
                    for (var i = 0; i < cookies.length; i++) {
                        var cookie = cookies[i].trim();
                        // Does this cookie string begin with the name we want?
                        if (cookie.substring(0, name.length + 1) === (name + '=')) {
                            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                            break;
                        }
                    }
                }
                return cookieValue;
        },
        selectAutocomplete(data) { 
            this.inputData = data[this.autocomplete_select_field] || '';
            this.showAutocomplete = false;
            this.autocompleteResults = [];
            this.autocompleteIndex = -1;
            this.$emit('input', this.inputData);
        },
        autocompleteBuildTextField(record){
            let textField = this.autocompleteTextField
            let isSimple = true
            while(textField.includes('{') && textField.includes('}')){
                const match = textField.match(/{([^}]+)}/)
                textField = textField.replace(match[0], record[match[1]])
                isSimple = false
            }
            return isSimple ? record[this.autocompleteTextField] : textField
        },
        enterPressed(e){
            if(this.autocomplete && this.autocompleteIndex >= 0){
                console.log('enterPressed in autocomplete',e);
                e.preventDefault();
                this.selectAutocomplete(this.autocompleteResults[this.autocompleteIndex]);
            }
            else{
                this.$emit('inputenter',e);
            }
        },
        autocompleteDown(e){
            e.preventDefault();
            this.autocompleteMove(1);
        },
        autocompleteUp(e){
            e.preventDefault();
            this.autocompleteMove(-1);
        },
        autocompleteMove(direction){
            if(this.autocompleteResults.length > 0){
                this.autocompleteIndex = (this.autocompleteIndex + direction + this.autocompleteResults.length) % this.autocompleteResults.length;
                //this.inputData = this.autocompleteResults[this.autocompleteIndex][this.autocomplete_select_field] || '';
            }
        },
        async inputChange(event) {
            // validate() is async so await the result before checking control digit
            this.validStatus = await this.validate()
            if(this.validStatus === true){
                if(this.control_digit) {
                    if(this.checkControlSum(this.inputData) == true) {
                        this.validClass = "valid";
                    } else {
                        this.validClass = "warning";
                    }
                } else{
                    this.validClass = "valid";
                }
            } else {
                this.validClass = "invalid";
            }
            this.$emit('change',this.inputData,this.name,this.validStatus)
            this.$emit('input', this.inputData);
            
            //TODO - debounce this
            if(this.autocomplete == true && this.inputData.length > 0){
                try {
                    var response = await axios.get(this.url+this.inputData,{headers: {'X-CSRFToken':this.getCookie('csrftoken')}})
                    this.autocompleteResults = response.data;
                    this.autocompleteIndex = -1;
                    this.showAutocomplete = true;
                } catch (error) {
                    console.error('Error fetching data:', error);
                    this.showAutocomplete = false;
                    this.autocompleteResults = [];
                    this.autocompleteIndex = -1;
                }
                
            } else {
                this.showAutocomplete = false;
                this.autocompleteResults = [];
                this.autocompleteIndex = -1;
            }
        },

        checkControlSum(full_number) {
            var number = full_number.substring(0,full_number.length-1)
            var sum = 0;
            var factor = 3;
            for(var i=0;i<number.length;i++) {
                sum += parseInt(number[number.length-i-1])*factor;
                factor = 4 - factor;
            }
            nearDec = (Math.ceil(sum/10))*10;
            var controlDigit = nearDec - sum;
            return controlDigit == parseInt(full_number[full_number.length-1]);
        },

        async validate() {
            if(this.inputData.length==0) {
                if(!this.required){
                    this.validClass="empty";
                    return "empty";
                }
                if(this.required) {
                    this.validClass="invalid"
                    return false
                }
            }
            
            if(typeof this.selected_regex=="undefined"){
                this.validClass="empty";
                return true;
            }

            if(this.validateFuncActive == true && this.validateFunc !== null){
                const result = await this.validateFunc(this.inputData);
                if(result === true){
                    this.validClass="valid";
                    return true;
                } else {
                    this.validClass="invalid";
                    return false;
                }
            }

            var match_result = this.inputData.match(this.selected_regex);
            if(match_result==null) {
                this.validClass="invalid"
                return false
            } else {
                this.validClass="valid"
                return true
            }
        },
        giveFocus(){
            if(this.date){
                this.$refs['date'].focus();
            }
            else{
                this.$refs['non-date'].focus();
            }
        }
    },
    data() {
        return {
            flatpickrInstance: undefined,
            validationRegex:{
                ip:/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gm,
                email:/.*?@.*?\.[a-zA-Z0-9]+/gm
            },
            inputData:'',
            validClass:"empty",
            validStatus:false,
            showAutocomplete: false,
            autocompleteResults: [],
            autocompleteIndex: -1,
        }
    },
    watch:{
        value:{
            immediate: true,
            handler() {
                this.inputData = this.value;
                this.inputChange()
            }
        },
        invalid_text(newValue) {
            if(newValue !== '') {
                this.validClass = "invalid";
                return;
            }
            this.inputChange()
        }
    }
}
</script>
<style>
.prepend-container {
    margin-top:0.5rem;
}
.autocomplete-list {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    background: white;
    border: 1px solid #ccc;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 0;
}
.autocomplete-list li {
    padding: 0.5rem;
    cursor: pointer;
}
.autocomplete-list li:hover {
    background: #eee;
}
.autocomplete-list li {
    font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Arial", sans-serif;
}
.autocomplete-list li.active {
    background: lightblue;
}
</style>
